module.exports = __webpack_public_path__ + "static/media/sound.bafe4c75.mp3";